import Route from '@ember/routing/route';
import { get, set } from '@ember/object';
import { service } from '@ember/service';

export default Route.extend({
  navbarSettings: service(),
  store: service(),

  beforeModel() {
    set(this, 'navbarSettings.title', 'Donor Hub Request Access');
  },

  model() {
    return this.store.findRecord('classic-site-token', 1).then((record) => {
      return {
        token: get(record, 'token'),
      };
    });
  },
});
